module.exports = __webpack_public_path__ + "static/about-isometric-f46a2257f6eec12f3be0f506ca879787.png";